import { DialogType } from '@tableau/widgets';
import React from 'react';

import { ModalInstance, ReactModalService } from '~commonInfra/dialogs/ReactModalService';
import { CommonStyles } from '~commonInfra/styles/CommonStyles';

import WebHttpClient from '../httpClient/WebHttpClient';
import { NotificationContainer } from './NotificationContainer';
import { NotificationDialog } from './NotificationDialog';
import { GetTabcldNotificationsRequest, IGetTabcldNotificationsResult } from './requests/GetTabcldNotificationsRequest';

const postLoginDialogStyle: React.CSSProperties = {
  width: 'auto',
  height: 'auto',
  paddingTop: CommonStyles.Sizes.SmallSpace,
  paddingBottom: CommonStyles.Sizes.SmallSpace,
  paddingLeft: CommonStyles.Sizes.SmallSpace,
  paddingRight: CommonStyles.Sizes.SmallSpace
};

export class TabcldPostloginNotification {
  public modalInstance: ModalInstance<unknown>;
  public notificationsEnabled: boolean;
  public notificationsShown: boolean;
  public checkboxIsClicked: boolean;

  constructor() {
    this.notificationsEnabled = false;
    this.notificationsShown = false;
    this.checkboxIsClicked = false;
  }

  public enableNotifications(): void {
    this.notificationsEnabled = true;
  }

  public notificationEnabled() {
    return this.notificationsEnabled;
  }

  public showTabcldNotificationsIfEnabled() {
    if (!this.notificationsEnabled || this.notificationsShown) {
      return;
    }

    this.fetchNotifications('POD', 'popup').then((data: any) => {
      var notificationContainer = new NotificationContainer(data);
      if (notificationContainer.getSize() > 0) {
          const dialogProps = {
            index: 0,
            notificationContainer: notificationContainer,
            closeModal: this.closeModal
          };

          this.modalInstance = ReactModalService.open({
              type: DialogType.Uber,
              dialogContent: React.createElement(NotificationDialog, dialogProps),
              testId: 'tabcld-postlogin-id',
              showCloseButton: true,
              dialogStyle: postLoginDialogStyle,
              shouldNotSetDefaultWidth: true
          });
        }
    }).finally(() => {
      this.notificationsShown = true;
    }); // Suppress in case of future remounting
  }

  public closeModal() {
    tabcldPostloginNotification.modalInstance.close();
  }

  private fetchNotifications(scope: string, location?: string): Promise<any[]> {
    return WebHttpClient.sendRequest(new GetTabcldNotificationsRequest(scope, location))
      .then((result: IGetTabcldNotificationsResult) => result.notificationList);
  }

}

export const tabcldPostloginNotification = new TabcldPostloginNotification();
